import { useTranslation } from "react-i18next";
import ConfirmationDialog from "@components/ConfirmationDialog";

const NavigationBlockerDialog = ({
  showConfirmDialog,
  handleCloseEvent,
  handleYesEvent,
  bodyTemplate = null,
  positiveButtonLabel = null,
  negativeButtonLabel = null,
  positiveButtonLoader = false,
  width = "35vw",
  discardButtonLabel = null,
  handleDiscardEvent = null,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      width={width}
      showConfirmDialog={showConfirmDialog}
      bodyTemplate={
        <p className="text-lg font-light-poppins text-dawn-gray">
          {bodyTemplate || t("common.backNavigationMessage")}
        </p>
      }
      negativeButtonLabel={negativeButtonLabel || t("common.cancel")}
      positiveButtonLabel={positiveButtonLabel || t("common.yesBack")}
      positiveButtonDisable
      positiveButtonLoader={positiveButtonLoader}
      handleCloseEvent={handleCloseEvent}
      handleYesEvent={handleYesEvent}
      showHeaderCloseIcon={false}
      extraButtonLabel={discardButtonLabel}
      handleExtraEvent={handleDiscardEvent}
    />
  );
};

export default NavigationBlockerDialog;
